var map = {
	"./assustado.png": 1025,
	"./falando.png": 8219,
	"./falando2.png": 5489,
	"./falando_feliz.png": 4658,
	"./falando_feliz2.png": 9866,
	"./feliz.png": 5848,
	"./normal.png": 6739,
	"./sorriso.png": 2341,
	"./sorriso2.png": 7939,
	"./triste.png": 5985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3043;